import { utilsApp } from "../utils-app_v2.js";
import { colors } from "../colors_v2.js";
import { identityService } from "../profile/identityService_v2.js";
import { matchService } from "./matchService_v2.js";
import { scoreBoard } from "../scoreBoard/scoreBoard_v2.js";
import { board } from "../game/gameBoard_v2.js";
import { searchName } from "./searchNamePop_v2.js";
import { dasModal } from "../modal_v2.js";
import { action } from "../game/action_v2.js";
import { COMPUTER_NAME, COMPUTER_USERID, TROUBLESHOOTING, MESSAGE_MAX_LENGTH } from "../constants_v2.js";
import { findForbiddenChars, findBannedWords } from "../textFilter_v2.js";
import { iPop } from "../ipop_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";

var newMatchState = {
  size: "small",
  owner: "playsFirst",
  opponent: "personOwnDevice",
  visibility: "publicRadio",
  participation: "audienceOnly",
  newSearchP1: "", //it's the name attribute, not just the user ID
  newSearchP2: "", //it's the name attribute, not just the user ID
  message: "",
};

const getSize = () => {
  return newMatchState.size;
};

const render = (size) => {
  const newMatchNav = document.getElementById("newNav");
  newMatchNav.classList.add("sectionNarrow");
  const newMatchSection = document.getElementById("newSection");
  switch (size) {
    case "normal":
      const modalBehinder = document.getElementById("modalBehinder");
      modalBehinder.dataset.action = "closeNewMatch";
      modalBehinder.style.display = "block";

      newMatchState.size = "normal";
      newMatchSection.style.width = utilsApp.calculateSectionWidth();
      // const htmlNormal = `
      //   <div id="sectionHeaderArea" class="vertical newLeftColumn">
      //     <div class="menu">New Match</div>
      //   </div>
      //   <div id="newRightColumn">
      //     <form id="newMatchForm">
      //       <div id="newRightColumnUpperRow">
      //         <div id="newRightColumnUpperLeftQuad">
      //           <div id="setUpNewMatch">
      //             <div id="ownerContainer">
      //               <span class='newHeader'>Owner: </span><br><span class='courier'>
      //                 <div class="loadingUserBlank shimmer"></div>
      //               </span>
      //             </div>
      //             <div id="playingOn">
      //               <input type="radio" id="playsFirst" name="owner" value="playsFirst">
      //               <label for="playsFirst">Plays First</label><br>
      //               <input type="radio" id="playsSecond" name="owner" value="playsSecond">
      //               <label for="playsSecond">Plays Second</label><br>
      //               <input type="radio" id="notAPlayer" name="owner" value="notAPlayer">
      //               <label for="notAPlayer">Not a Player</label><br>
      //             </div>
      //           </div>
      //         </div>
      //         <div id="newMatchRightColumnUpperRightQuad">
      //           <div id="newMatchPlayers">
      //             <span class="loadingNewMatchPlayers shimmer">Loading...</span>
      //           </div>
      //         </div>
      //       </div>
      //       <div id="newRightColumnLowerRow">
      //         <div id="newMatchRightColumnlowerLeftQuad">
      //           <div><span class=newHeader>Watchers:</span><br>
      //             <label class="indentedLabel" for="privateRadio">
      //               <input type="radio" id="privateRadio" name="visibility" value="privateRadio">
      //               Only invited people</label>
      //             <label class="indentedLabel" for="publicRadio">
      //               <input type="radio" id="publicRadio" name="visibility" value="publicRadio">
      //               Anyone</label>
      //           </div>
      //         </div>
      //         <div id="newMatchRightColumnlowerRightQuad">
      //             <div><span class=newHeader>Audience Participation:</span><div id="participationSplainer" class="i">ⓘ</div><br>
      //               <label class="indentedLabel" for="audienceOnly">
      //                 <input type="radio" id="audienceOnly" name="participation" value="audienceOnly">
      //                 Watchers Only</label>
      //               <label class="indentedLabel" for="everyone">
      //                 <input type="radio" id="everyone" name="participation" value="everyone" >
      //                 Watchers and Players</label>
      //               <label class="indentedLabel" for="disable">
      //                 <input type="radio" id="disable" name="participation" value="disable" >
      //                 Disable</label>
      //             </div>
      //         </div>
      //       </div>
      //     <div class="center">
      //       <div id="newButtons"></div>
      //       <p><em> These settings cannot be changed after a match is created.</em>
      //       </p>
      //     </div>
      //     </form>
      //   </div>
      //   <div id="closeNewMatch" class = "x"></div>

      // `;
      const htmlNormal = `
        <div id="sectionHeaderArea" class="vertical newLeftColumn">
          <div class="menu">New Match</div>
        </div>
        <div id="newRightColumn">
          <form id="newMatchForm">
            <div id="newRightColumnUpperRow">
              <div id="newRightColumnUpperLeftQuad">
                <div id="setUpNewMatch">
                  <div id="ownerContainer">
                    <span class='newHeader'>Owner: </span><br><span class='courier'>
                      <div class="loadingUserBlank shimmer"></div>
                    </span> 
                  </div>
                  <div id="playingOn">
                    <input type="radio" id="playsFirst" name="owner" value="playsFirst">
                    <label for="playsFirst">Plays First</label><br>
                    <input type="radio" id="playsSecond" name="owner" value="playsSecond">
                    <label for="playsSecond">Plays Second</label><br>
                    <input type="radio" id="notAPlayer" name="owner" value="notAPlayer">
                    <label for="notAPlayer">Not a Player</label><br>
                  </div>
                </div>
              </div>
              <div id="newMatchRightColumnUpperRightQuad">
                <div id="newMatchPlayers">
                  <span class="loadingNewMatchPlayers shimmer">Loading...</span>
                </div>
              </div>
            </div>
            <div id="newMatchMessageSection">
              <span class="currentMatchMessageLabel">Invitation Message:</span><span class="i" id="newMatchMessageSplainer">ⓘ</span><br>
              <textarea id="newMatchMessage" name="message" maxlength="${MESSAGE_MAX_LENGTH}" placeholder="Enter a message for your opponent" rows="1" style="width: 100%; resize: vertical; min-height: 24px;">${escapeHtml(newMatchState.message || "")}</textarea>
              <div class="inputMessages center" id="newMatchMsg"></div>
              <div class="inputMessages center" id="newMatchMessageForbiddenCharsMsg"></div>
              <div class="inputMessages center" id="newMatchMessageBannedWordsMsg"></div>
              <div class="messageCharCounter" id="messageCharCounter"></div>
            </div>
          <div class="center">
            <div id="newButtons"></div>
            <p><em> These settings cannot be changed after a match is created.</em>
            </p>
          </div>
          </form>
        </div>
        <div id="closeNewMatch" class = "x"></div>
        
      `;
      newMatchSection.classList.add("sectionWide");
      newMatchSection.innerHTML = htmlNormal;
      renderPlayers();
      renderOwner();
      setRadiosChecked();
      updateMessageTextareaState();
      updateMessageCharCounter();

      colors.setButtonColors();
      document.getElementById("newRightColumnUpperRow").style.backgroundColor =
        colors.getGameColor("tip");
      document.getElementById("newMatchMessage").style.backgroundColor =
        colors.getGameColor("lighterAccent");
      document.getElementById("newMatchMessageSection").style.backgroundColor =
        colors.getGameColor("tip");
      document.getElementById("newMatchMessageSection").style.borderRadius =
        "10px";
      document.getElementById("newMatchMessageSection").style.padding =
        "10px";
      // document.getElementById("newRightColumnLowerRow").style.backgroundColor =
      //   colors.getGameColor("tip");
      utilsApp.adjust4Mobile();

      break;
    case "small":
      newMatchState.size = "small";
      newMatchSection.style.width = "0px";
      newMatchSection.innerHTML = "";
      newMatchSection.className = "";
      searchName.close();
      break;
    default:
      console.log(
        "Error: Attempting to render newMatch to invalid size: " + size,
      );
      return;
  }
  colors.setNavColors();
  newMatchSection.style.borderColor = colors.getGameColor("hexGrid");
  newMatchNav.style.borderColor = colors.getGameColor("hexGrid");
};

const closeNewMatch = () => {
  newMatchState.newSearchP1 = "";
  newMatchState.newSearchP2 = "";
  // Don't clear message - preserve it for next time
  // newMatchState.message = "";
  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.style.display = "none";
  delete modalBehinder.dataset.action;
  render("small");
};

const renderParticipationSplainer = (event) => {
  iPop.render({
    text: "A real time overlay showing where the audience members would play.",
    event,
  });
};

const renderOwner = async () => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return { status: pAIdentityResponse.status };
  }
  const pAIdentity = pAIdentityResponse.identity;
  document.getElementById("ownerContainer").innerHTML =
    "<span class='newHeader'>Owner: </span><br><span class='courier'>" +
    pAIdentity.pANameHtml +
    "</span>";
};

const renderPlayers = async () => {
  let htmlTop;
  let htmlBottom;
  var podLabel = await figureOutPodLabel();
  const htmlRadios = `
    <label class="indentedLabel" for="computer">
      <input type="radio" id="computer" name="opponent" value="computer"/>
      ${identityService.parseName(
        COMPUTER_NAME,
      )}<div id="wartSplainer" class="i">ⓘ</div></label>
    <label class="indentedLabelThisDevice" for="personThisDevice">
      <input type="radio" id="personThisDevice" name="opponent" value="personThisDevice"/>
      <div class="flexRow playDevice">
        <div id="playOwnDevice">
          They play on your device
        </div>
        <div class="deviceSplainerText">
          (i.e. sitting next to you)
        </div>
      </div>
    </label>
    <label class="indentedLabelOwnDevice" for="personOwnDevice">
      <input type="radio" id="personOwnDevice" name="opponent" value="personOwnDevice"/>
      <div class="flexRow playDevice">
        <div id="podLabelDiv">
          They play on their device
        </div>
        <div class="deviceSplainerText">
              ${podLabel}
        </div>
      </div>
    </label>

       
  `;
  switch (true) {
    case newMatchState.owner === "playsFirst":
      htmlTop = `<span class=newHeader>Playing Second:</span><br>`;
      htmlBottom = htmlRadios;
      break;
    case newMatchState.owner === "playsSecond":
      htmlTop = `<span class=newHeader>Playing First:</span><br>`;
      htmlBottom = htmlRadios;
      break;
    case newMatchState.owner === "notAPlayer":
      htmlTop = ``;
      if (identityService.gotLoggedOnUser()) {
        htmlBottom = `<div class="notPlayerSplainer">This option is for arranging tournaments, etc.</div> `;
      } else {
        htmlBottom = `<div class="notPlayerSplainer">Not Allowed.<br><br>To arrange a match for others (events, tournaments, etc.), please log in.</div> `;
      }
      break;
  }
  document.getElementById("newMatchPlayers").innerHTML = htmlTop + htmlBottom;
  setRadiosChecked();
  renderActionButtons();
};

const renderWartSplainer = (event) => {
  iPop.render({
    text: "The default computer algorithm is named Wart. Once you master the fundamentals, you can usually beat it.",
    event,
  });
};

const renderNewMatchMessageSplainer = (event) => {
  iPop.render({
    text: "Invitation messages help identify the match, but they are optional. They can not be edited after the match is created.",
    event,
  });
};

const renderCardMessageSplainer = (event) => {
  iPop.render({
    text: "Invitation message from the match owner",
    event,
  });
};

const renderAddSplainer = (event) => {
  iPop.render({
    text: `Two ways to add people: <ol><li class="left">Use the Add Account button now</li><li class="left">Get them a join code<div id="nmjoinCodeSplainer" class="i">ⓘ</div> later</li></ol>`,
    event,
  });
};

const renderJoinCodeSplainer = (event) => {
  iPop.render({
    text: "Join Codes are found under Current Match",
    event,
  });
};

const figureOutPodLabel = async () => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return { status: pAIdentityResponse.status };
  }
  const pAIdentity = pAIdentityResponse.identity;
  const pAUserID = pAIdentity.userID;

  const newSearchP1 = newMatchState.newSearchP1;
  const newSearchP2 = newMatchState.newSearchP2;
  const owner = newMatchState.owner;

  const defaultText = `
      <span class="noWrap"><button type="button" class = "accountInviteButton" id=${
        owner === "playsFirst" ? "newSearchP2" : "newSearchP1"
      }>Add Account (Optional)</button><div id="addAccountSplainer" class="i">ⓘ</div></span>
  `;

  // default: No search has happened yet, and newSearchP1 and newSearchP2 are empty
  if (newSearchP1.length === 0 && newSearchP2.length === 0) {
    return defaultText; //
  }

  // newSearchP1 or newSearchP2 are not empty
  // That means a search has happened.
  // Let's make sure they didn't pick their own identity

  // case 1: What if the owner is playing second and newSearchP1 has a name?
  if (owner === "playsSecond" && newSearchP1.length > 0) {
    const newSearchP1ID = identityService.parseUserID(newSearchP1);
    if (pAUserID === newSearchP1ID) {
      renderSameSameError();
      return defaultText;
    } else {
      return `<span class='courier'>${escapeHtml(newMatchState.newSearchP1)}</span>`;
    }
  }

  // case 2: What if the owner is playing second and newSearchP2 has a name?
  // This could happen if it was previously set
  if (owner === "playsSecond" && newSearchP2.length > 0) {
    const newSearchP2ID = identityService.parseUserID(newSearchP2);
    if (pAUserID === newSearchP2ID) {
      renderSameSameError();
      return defaultText;
    } else {
      return `<span class='courier'>${escapeHtml(newMatchState.newSearchP2)}</span>`;
    }
  }

  // case 3: What if the owner is playing first, and newSearchP1 has a name?
  if (owner === "playsFirst" && newSearchP1.length > 0) {
    const newSearchP1ID = identityService.parseUserID(newSearchP1);
    if (pAUserID === newSearchP1ID) {
      renderSameSameError();
      return defaultText;
    } else {
      return `<span class='courier'>${escapeHtml(newMatchState.newSearchP1)}</span>`;
    }
  }

  // case 4: What if the owner is playing first, and newSearchP2 has a name?
  // This could happen if it was previously set
  if (owner === "playsFirst" && newSearchP2.length > 0) {
    const newSearchP2ID = identityService.parseUserID(newSearchP2);
    if (pAUserID === newSearchP2ID) {
      renderSameSameError();
      return defaultText;
    } else {
      return `<span class='courier'>${escapeHtml(newMatchState.newSearchP2)}</span>`;
    }
  }
};

const renderSameSameError = () => {
  // clear both of these out:
  newMatchState.newSearchP1 = "";
  newMatchState.newSearchP2 = "";
  // Somtimes the modal hasn't closed from previous call. so Let's just give it a littl bit...
  setTimeout(() => {
    dasModal.render(
      `<div id="sameSameError">The opponent has to be a different player.<div>`,
    );
  }, 100);
};

const setRadiosChecked = () => {
  // step one: Uncheck everything
  // can't assume anything is in the DOM...
  //owner
  const playsFirst = document.getElementById("playsFirst");
  if (document.body.contains(playsFirst)) {
    playsFirst.checked = false;
  }
  const playsSecond = document.getElementById("playsSecond");
  if (document.body.contains(playsSecond)) {
    playsSecond.checked = false;
  }
  const notAPlayer = document.getElementById("notAPlayer");
  if (document.body.contains(notAPlayer)) {
    notAPlayer.checked = false;
  }

  //opponent
  const personThisDevice = document.getElementById("personThisDevice");
  if (document.body.contains(personThisDevice)) {
    personThisDevice.checked = false;
  }
  const personOwnDevice = document.getElementById("personOwnDevice");
  if (document.body.contains(personOwnDevice)) {
    personOwnDevice.checked = false;
  }
  const computer = document.getElementById("computer");
  if (document.body.contains(computer)) {
    computer.checked = false;
  }

  //visibility
  const privateRadio = document.getElementById("privateRadio");
  if (document.body.contains(privateRadio)) {
    privateRadio.checked = false;
  }
  const publicRadio = document.getElementById("publicRadio");
  if (document.body.contains(publicRadio)) {
    publicRadio.checked = false;
  }

  //participation
  const audienceOnly = document.getElementById("audienceOnly");
  if (document.body.contains(audienceOnly)) {
    audienceOnly.checked = false;
  }
  const everyone = document.getElementById("everyone");
  if (document.body.contains(everyone)) {
    everyone.checked = false;
  }
  const disable = document.getElementById("disable");
  if (document.body.contains(disable)) {
    disable.checked = false;
  }

  // step two: check the radio that is stored in state
  // can't assume anything is in the Dom...
  const ownerElement = document.getElementById(newMatchState.owner);
  if (document.body.contains(ownerElement)) {
    ownerElement.checked = true;
  }
  const opponentElement = document.getElementById(newMatchState.opponent);
  if (document.body.contains(opponentElement)) {
    opponentElement.checked = true;
  }
  const visibilityElement = document.getElementById(newMatchState.visibility);
  if (document.body.contains(visibilityElement)) {
    visibilityElement.checked = true;
  }
  const participationElement = document.getElementById(
    newMatchState.participation,
  );
  if (document.body.contains(participationElement)) {
    participationElement.checked = true;
  }
};

const isRadioValid = (element) => {
  const validElements = [
    "playsFirst",
    "playsSecond",
    "notAPlayer",
    "personThisDevice",
    "personOwnDevice",
    "computer",
    "privateRadio",
    "publicRadio",
    "audienceOnly",
    "everyone",
    "disable",
  ];
  if (validElements.includes(element)) {
    return true;
  }
  return false;
};

const updateMessageTextareaState = () => {
  const messageTextarea = document.getElementById("newMatchMessage");
  if (!messageTextarea) return;

  // Only enable message when playing against someone on their own device
  const opponentSelection = newMatchState.opponent;
  const isValidOpponent = opponentSelection === "personOwnDevice";
  messageTextarea.disabled = !isValidOpponent;
};

const handleRadioChange = (event) => {
  const radioName = event.target.name;
  const gotClicked = event.target.id;
  if (!isRadioValid(gotClicked)) {
    // probably overkill, but you never know...
    console.log("ERROR: This is not a valid Radio: " + gotClicked);
    return;
  }

  newMatchState[radioName] = gotClicked;

  // Enable/disable message textarea based on opponent selection
  updateMessageTextareaState();

  render("normal"); //re render with the new radio selection
};

const renderActionButtons = () => {
  const opponent = newMatchState.opponent;
  const owner = newMatchState.owner;
  const gotLoggedOnUser = identityService.gotLoggedOnUser();
  const newButtons = document.getElementById("newButtons");

  switch (true) {
    case opponent === "personOwnDevice" && owner != "notAPlayer":
      newButtons.innerHTML = `
      <button type="submit" class="newActionButton" id="newMatch">Create</button>
      <div class="inputMessages center" id="newMatchMsg"></div>
      `;

      const newSearchP1 = document.getElementById("newSearchP1");
      const newSearchP2 = document.getElementById("newSearchP2");

      colors.setButtonColors();
      break;
    case opponent != "personOwnDevice" && owner != "notAPlayer":
      newButtons.innerHTML = `
      <button type="submit" class="newActionButton" id="newMatch">Create</button>
      <div class="inputMessages center" id="newMatchMsg"></div>
      `;
      colors.setButtonColors();
      break;
    case owner === "notAPlayer" && !gotLoggedOnUser:
      newButtons.innerHTML = ``; //not a thing
      break;
    case owner === "notAPlayer" && gotLoggedOnUser:
      if (
        newMatchState.newSearchP1.length > 0 &&
        newMatchState.newSearchP2.length > 0 &&
        newMatchState.newSearchP1 === newMatchState.newSearchP2
      ) {
        renderSameSameError();
      }
      // invitees' names come from search results: other users' data
      const p1ButtonText =
        newMatchState.newSearchP1.length > 0
          ? `<span class=courier> ${escapeHtml(newMatchState.newSearchP1)}</span>`
          : "Plays First";
      const p2ButtonText =
        newMatchState.newSearchP2.length > 0
          ? `<span class=courier> ${escapeHtml(newMatchState.newSearchP2)}</span>`
          : "Plays Second";
      newButtons.innerHTML = `
      <div id="newThirdRow">
        <div id="newThirdRowTop">
          <span class=noWrap>
          <div id="newSearchLabel" for="newSearch"><em>Add Account (optional)</em><div id="addAccountSplainer1" class="i">ⓘ</div></div>
          </span>
        </div>
        <div id="newThirdRowBottom">
          <div id="thirdRowLeft">
            <button type="button" class="notAPlayerInviteButtons" id="newSearchP1">${p1ButtonText}</button>
          </div>
          <div id="thirdRowRight">
            <button type="button" class="notAPlayerInviteButtons" id="newSearchP2">${p2ButtonText}</button>
          </div>
        </div>
      </div>
      
      <button type="submit" class="newActionButton" id="newMatch">Create</button>
      <div class="inputMessages center" id="newMatchMsg"></div>
      `;
      colors.setButtonColors();
      document.getElementById("newThirdRow").style.backgroundColor =
        colors.getGameColor("tip");
  }
};

const handleStartSearchClick = (event, element) => {
  // console.log(element);
  // console.log(event);
  newMatchState.opponent = "personOwnDevice";
  if (!newMatchState.owner === "NotAPlayer") {
    document.getElementById("personOwnDevice").checked === true;
    document.getElementById("personThisDevice").checked === false;
    document.getElementById("computer").checked === false;
  }
  const gotClicked = element.id;
  const params = {
    sendToModule: "newMatch",
    player: gotClicked,
  };
  searchName.render(params);
};

/**
 * @brief Set the name of the invitee
 * @param input an object with three keys:
 * * sendToModule must be "startMatch" in this case (could be different for other modules)
 * * player must be "newSearchP1" or "newSearchP2" in this case (could be different for other modules)
 * * name must be a valid name in the game format
 * @returns {{status: number, message: string}} The return object has two keys:
 * * status is a number 200 or 400
 * * message is an error message if status is not 200
 */
const setInviteeName = (input) => {
  const keys = Object.keys(input);

  const hasSendTo = Object.prototype.hasOwnProperty.call(input, "sendToModule");
  if (!hasSendTo) {
    const message = "Error: sendToModule is missing";
    return { status: 400, message };
  }
  if (input.sendToModule != "newMatch") {
    const message =
      "Error: the value of sendToModule must be 'newMatch' but instead this was received: " +
      input.sendToModule;
    return { status: 400, message };
  }
  if (!keys.includes("player")) {
    const message = "Error: player is missing";
    return { status: 400, message };
  }
  if (!keys.includes("name")) {
    const message = "Error: name is missing";
    return { status: 400, message };
  }
  if (!(input.player === "newSearchP1" || input.player === "newSearchP2")) {
    const message =
      "Error: player must be 'newSearchP1' or 'newSearchP2' but instead this was received: " +
      input.player;
    return { status: 400, message };
  }
  // A stored full name ("Harry (RBXAV3B)"), so check its shape. isNameValid
  // is for typing a NEW name part, and parentheses aren't allowed there.
  if (!identityService.isFullNameShapeValid(input.name)) {
    const message = "Error: that account's name isn't in the expected format.";
    return { status: 400, message };
  }
  if (input.player === "newSearchP1") {
    newMatchState.newSearchP1 = input.name;
  }
  if (input.player === "newSearchP2") {
    newMatchState.newSearchP2 = input.name;
  }
  render("normal");
  return { status: 200 };
};

const checkMessageForBannedWords = (message) => {
  const bannedWordsMsg = document.getElementById("newMatchMessageBannedWordsMsg");
  if (!bannedWordsMsg) return false;

  // Shared filter: whole words and phrases, case-insensitive, punctuation at
  // word edges ignored. Same rules the back end uses.
  if (findBannedWords(message).length > 0) {
    bannedWordsMsg.textContent = "An offensive word was detected. Please remove it";
    bannedWordsMsg.style.color = "red";
    return true;
  }

  // Clear the error message if no banned words found
  bannedWordsMsg.textContent = "";
  bannedWordsMsg.style.color = "";
  return false;
};

const checkMessageForForbiddenChars = (message) => {
  const forbiddenCharsMsg = document.getElementById("newMatchMessageForbiddenCharsMsg");
  if (!forbiddenCharsMsg) return false;

  const foundForbidden = findForbiddenChars(message);

  if (foundForbidden.length > 0) {
    forbiddenCharsMsg.textContent = `Can not contain these characters: ${foundForbidden.join(" ")}`;
    forbiddenCharsMsg.style.color = "red";
    return true;
  }

  // Clear the error message if no forbidden characters found
  forbiddenCharsMsg.textContent = "";
  forbiddenCharsMsg.style.color = "";
  return false;
};

const updateMessageCharCounter = () => {
  if (TROUBLESHOOTING) {
    console.log("updateMessageCharCounter called");
    const messageTextarea = document.getElementById("newMatchMessage");
    const counterDisplay = document.getElementById("messageCharCounter");
    console.log("messageTextarea:", messageTextarea);
    console.log("counterDisplay:", counterDisplay);
    if (!messageTextarea || !counterDisplay) {
      console.log("Missing elements, returning");
      return;
    }

    const message = messageTextarea.value;
    const charCount = message.length;
    const maxChars = MESSAGE_MAX_LENGTH;
    const threshold = 5; // Show counter after typing 5 chars (was 50, lowered for testing)

    console.log("charCount:", charCount, "threshold:", threshold);
  }

  const messageTextarea = document.getElementById("newMatchMessage");
  const counterDisplay = document.getElementById("messageCharCounter");
  if (!messageTextarea || !counterDisplay) return;

  const message = messageTextarea.value;
  const charCount = message.length;
  const maxChars = MESSAGE_MAX_LENGTH;
  const threshold = 5; // Show counter after typing 5 chars

  if (charCount >= threshold) {
    counterDisplay.classList.remove("hide");
    counterDisplay.textContent = `${charCount}/${maxChars}`;

    if (charCount > maxChars) {
      counterDisplay.style.color = "red";
      counterDisplay.style.fontWeight = "bold";
    } else {
      counterDisplay.style.color = "";
      counterDisplay.style.fontWeight = "";
    }
  } else {
    counterDisplay.classList.add("hide");
  }
};

const handleNewMatchMessageInput = (event) => {
  const messageInput = document.getElementById("newMatchMessage");
  const newMatchMsg = document.getElementById("newMatchMsg");
  const message = messageInput ? messageInput.value : "";
  
  // Trim whitespace for storage
  const trimmedMessage = message.trim();
  
  // Check length (max ${MESSAGE_MAX_LENGTH} chars)
  if (trimmedMessage.length > MESSAGE_MAX_LENGTH) {
    newMatchMsg.textContent = "Message is too long (max ${MESSAGE_MAX_LENGTH} characters)";
    newMatchMsg.style.color = "red";
    return;
  }
  
  // Clear any forbidden character error on input
  const forbiddenMsg = document.getElementById("newMatchMessageForbiddenCharsMsg");
  if (forbiddenMsg) {
    forbiddenMsg.textContent = "";
    forbiddenMsg.style.color = "";
  }
  
  // Check for forbidden characters in the ORIGINAL message (before sanitization)
  checkMessageForForbiddenChars(trimmedMessage);
  
  // Check for banned words
  checkMessageForBannedWords(trimmedMessage);
  
  // Basic sanitization - strip any HTML tags and escape special characters
  const sanitizedMessage = trimmedMessage
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
  
  // Update state
  newMatchState.message = sanitizedMessage;
  
  // Clear any error messages on valid input
  newMatchMsg.textContent = "";
};

const handleNewMatchMessageBlur = (event) => {
  const messageInput = document.getElementById("newMatchMessage");
  const newMatchMsg = document.getElementById("newMatchMsg");
  const message = messageInput ? messageInput.value : "";
  
  // Final validation on blur
  if (message.trim().length > MESSAGE_MAX_LENGTH) {
    newMatchMsg.textContent = "Message is too long (max ${MESSAGE_MAX_LENGTH} characters)";
    newMatchMsg.style.color = "red";
  } else {
    newMatchMsg.textContent = "";
  }
  
  // Check for forbidden characters
  checkMessageForForbiddenChars(message);
  
  // Check for banned words
  checkMessageForBannedWords(message);
};

const handleNewMatchMessageInputWithCounter = (event) => {
  if (TROUBLESHOOTING) {
    console.log("handleNewMatchMessageInputWithCounter called");
  }
  handleNewMatchMessageInput(event);
  updateMessageCharCounter();
};

const handleNewMatchMessageFocus = (event) => {
  const messageInput = document.getElementById("newMatchMessage");
  if (messageInput && newMatchState.message && messageInput.value !== newMatchState.message) {
    messageInput.value = newMatchState.message;
  }
};

const handleNewMatchNavClick = (event) => {
  switch (getSize()) {
    case "small":
      render("normal");
      break;
    case "normal":
      render("small");
      break;
    default:
      render("small");
  }
};

/**
 *
 * @returns full name
 */
const getPlaysFirst = async () => {
  const opponent = newMatchState.opponent;
  const owner = newMatchState.owner;

  switch (true) {
    case owner === "notAPlayer":
      return newMatchState.newSearchP1.length > 0
        ? newMatchState.newSearchP1
        : "waiting";
    case owner === "playsFirst":
      const pAIdentityResponse = await identityService.getPlayingAs();
      if (pAIdentityResponse.status != 200) {
        // session expired
        return;
      }
      const pAIdentity = pAIdentityResponse.identity;
      return pAIdentity.name;
    case owner === "playsSecond" && opponent === "computer":
      return COMPUTER_NAME;
    case owner === "playsSecond" && opponent === "personThisDevice":
      const playerOne = await identityService.createIdentity({
        name: "Player One",
        type: "temp",
      });
      return playerOne.identity.name;
    case owner === "playsSecond" && opponent === "personOwnDevice":
      return newMatchState.newSearchP1.length > 0
        ? newMatchState.newSearchP1
        : "waiting";
  }
};

/**
 *
 * @returns full name
 */
const getPlaysSecond = async () => {
  const opponent = newMatchState.opponent;
  const owner = newMatchState.owner;
  switch (true) {
    case owner === "notAPlayer":
      return newMatchState.newSearchP2.length > 0
        ? newMatchState.newSearchP2
        : "waiting";
    case owner === "playsSecond":
      const pAIdentityResponse = await identityService.getPlayingAs();
      if (pAIdentityResponse.status != 200) {
        // session expired
        return;
      }
      const pAIdentity = pAIdentityResponse.identity;
      return pAIdentity.name;
    case owner === "playsFirst" && opponent === "computer":
      return COMPUTER_NAME;
    case owner === "playsFirst" && opponent === "personThisDevice":
      const playerTwo = await identityService.createIdentity({
        name: "Player Two",
        type: "temp",
      });
      return playerTwo.identity.name;
    case owner === "playsFirst" && opponent === "personOwnDevice":
      return newMatchState.newSearchP2.length > 0
        ? newMatchState.newSearchP2
        : "waiting";
  }
};

const getVisibility = () => {
  if (newMatchState.visibility === "privateRadio") {
    return "invited";
  } else {
    return "everyone";
  }
};

const getAudienceParticipation = () => {
  switch (true) {
    case newMatchState.participation === "audienceOnly":
      return "watchers";
    case newMatchState.participation === "everyone":
      return "everyone";
    case newMatchState.participation === "disable":
      return "disabled";
  }
};

const getMode = () => {
  if (newMatchState.owner === "notAPlayer") {
    return "ownDevice";
  }
  if (newMatchState.opponent === "computer") {
    return "sameDevice";
  }
  switch (newMatchState.opponent === "personThisDevice") {
    case true:
      return "sameDevice";
    case false:
      return "ownDevice";
  }
};

const handleCreateMatch = async (event) => {
  const newMatch = document.getElementById("newMatch");
  const newMatchMsg = document.getElementById("newMatchMsg");
  document.body.style.cursor = "wait";
  newMatch.style.cursor = "wait";
  newMatch.disabled = true;

  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    newMatch.disabled = false;
    newMatch.style.cursor = "default";
    newMatchMsg.textContent = "";
    document.body.style.cursor = "default";
    return { status: pAIdentityResponse.status };
  }
  const pAIdentity = pAIdentityResponse.identity;

  // Validate message before submitting
  const messageInput = document.getElementById("newMatchMessage");
  const message = messageInput ? messageInput.value.trim() : "";
  
  if (message.length > MESSAGE_MAX_LENGTH) {
    newMatch.disabled = false;
    newMatch.style.cursor = "default";
    newMatchMsg.textContent = "Message is too long (max ${MESSAGE_MAX_LENGTH} characters)";
    newMatchMsg.style.color = "red";
    document.body.style.cursor = "default";
    return;
  }
  
  // Check for forbidden characters
  const foundForbidden = findForbiddenChars(message);
  if (foundForbidden.length > 0) {
    const forbiddenMsg = document.getElementById("newMatchMessageForbiddenCharsMsg");
    if (forbiddenMsg) {
      forbiddenMsg.textContent = "Please remove these characters: " + foundForbidden.join(" ");
      forbiddenMsg.style.color = "red";
    }
    newMatch.disabled = false;
    newMatch.style.cursor = "default";
    document.body.style.cursor = "default";
    return;
  }
  
  // Check for banned words and phrases
  const bannedWords = findBannedWords(message);
  if (bannedWords.length > 0) {
    const bannedMsg = document.getElementById("newMatchMessageBannedWordsMsg");
    if (bannedMsg) {
      bannedMsg.textContent = "An offensive word was detected. Please remove it";
      bannedMsg.style.color = "red";
    }
    newMatch.disabled = false;
    newMatch.style.cursor = "default";
    document.body.style.cursor = "default";
    return;
  }
  
  // All validations passed, now show "Submitting..." and proceed
  newMatchMsg.textContent = "Submitting...";
  await new Promise(requestAnimationFrame);

  const params = {
    ownerName: pAIdentity.name,
    p1Name: await getPlaysFirst(),
    p2Name: await getPlaysSecond(),
    visibility: getVisibility(),
    audienceParticipation: getAudienceParticipation(),
    mode: getMode(), //match mode is "sameDevice" or "ownDevice".
    message: message, // Include the message field
  };
  if (params.p1Name === COMPUTER_NAME || params.p2Name === COMPUTER_NAME) {
    // what if someone invites wart?
    params.mode = "sameDevice";
  }
  const result = await matchService.create(params);
  document.body.style.cursor = "default";
  newMatch.style.cursor = "default";
  newMatch.disabled = false;
  newMatchMsg.textContent = "";

  if (result.status != 200) {
    newMatchMsg.textContent = "Error: Match not created";
    console.log("Error creating match: " + result.status);
    return; //don;t close it
  }
  // Clear message after successful creation
  newMatchState.message = "";
  closeNewMatch();
  utilsApp.makeNavsSmall();
  scoreBoard.render();
  action.renderSection();
  board.render(); // and we are off

  // if Wart is going first, this gets him going
  if (matchService.getTurn().userID === COMPUTER_USERID) {
    board.handleComputerTurn();
  }
};

eventHub.registerEvent("click", "newNav", handleNewMatchNavClick);
eventHub.registerEvent("click", "closeNewMatch", closeNewMatch); //modalBehinder
eventHub.registerEvent("change", "playsFirst", handleRadioChange);
eventHub.registerEvent("change", "playsSecond", handleRadioChange);
eventHub.registerEvent("change", "notAPlayer", handleRadioChange);
eventHub.registerEvent("change", "personThisDevice", handleRadioChange);
eventHub.registerEvent("change", "personOwnDevice", handleRadioChange);
eventHub.registerEvent("change", "computer", handleRadioChange);
eventHub.registerEvent("change", "privateRadio", handleRadioChange);
eventHub.registerEvent("change", "publicRadio", handleRadioChange);
eventHub.registerEvent("change", "audienceOnly", handleRadioChange);
eventHub.registerEvent("change", "everyone", handleRadioChange);
eventHub.registerEvent("change", "disable", handleRadioChange);
eventHub.registerEvent("click", "wartSplainer", renderWartSplainer);
eventHub.registerEvent("click", "newMatchMessageSplainer", renderNewMatchMessageSplainer);
eventHub.registerEvent(
  "click",
  "participationSplainer",
  renderParticipationSplainer,
);
eventHub.registerEvent("click", "newSearchP1", handleStartSearchClick);
eventHub.registerEvent("click", "newSearchP2", handleStartSearchClick);
eventHub.registerEvent("input", "newMatchMessage", handleNewMatchMessageInputWithCounter);
eventHub.registerEvent("blur", "newMatchMessage", handleNewMatchMessageBlur);
eventHub.registerEvent("focus", "newMatchMessage", handleNewMatchMessageFocus);
eventHub.registerEvent("click", "newMatch", handleCreateMatch);

// matchCard splainer
eventHub.registerEvent("click", "cardMessageSplainer", renderCardMessageSplainer);

eventHub.registerEvent("click", "addAccountSplainer", renderAddSplainer);
eventHub.registerEvent("click", "addAccountSplainer1", renderAddSplainer);
eventHub.registerEvent("click", "nmjoinCodeSplainer", renderJoinCodeSplainer);

export const newMatch = {
  getSize,
  render,
  setInviteeName,
};
